module.exports = __webpack_public_path__ + "static/media/EventsCarousel.6384c729.mp4";